var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center grey--text text-decoration-line-through"},[_c('span',{staticClass:"body-2 price"},[_vm._v(_vm._s(_vm.price))]),_c('span',{staticClass:"caption"},[_vm._v("/mês")])])
}
var staticRenderFns = []

export { render, staticRenderFns }